import { Command } from 'commander';
import { readFileSync } from 'fs';
import { ApiClient } from '../client.js';
import { formatOutput } from '../output.js';
import { getBase, getFormat } from '../helpers.js';

export const sqlCommand = new Command('sql')
  .description('Execute a read-only SQL query against database data')
  .argument('[query]', 'SQL query (SELECT only)')
  .option('--file <path>', 'Read SQL from a file instead of argument')
  .option('--param <kv...>', 'Named parameters as key=value pairs (e.g., --param status=issued)')
  .action(async function (this: Command, queryArg: string | undefined, opts: { file?: string; param?: string[] }) {
    const ws = getBase(this);
    const client = new ApiClient();

    let query: string;
    if (opts.file) {
      query = readFileSync(opts.file, 'utf-8').trim();
    } else if (queryArg) {
      query = queryArg;
    } else {
      console.error('Error: provide a SQL query as argument or via --file');
      process.exit(1);
    }

    const params: Record<string, unknown> = {};
    if (opts.param) {
      for (const kv of opts.param) {
        const eqIdx = kv.indexOf('=');
        if (eqIdx === -1) {
          console.error(`Error: invalid param format "${kv}", expected key=value`);
          process.exit(1);
        }
        params[kv.slice(0, eqIdx)] = kv.slice(eqIdx + 1);
      }
    }

    const body: Record<string, unknown> = { query };
    if (Object.keys(params).length > 0) body.params = params;

    const data = await client.request('POST', `/v1/${ws}/sql`, body);
    console.log(formatOutput(data, getFormat(this)));
  });
